import React from 'react';
import './Footer.css';


const Footer = () => {
    return (

        <footer className="text-center text-white" style={{
            backgroundColor: 'black',
            borderTop: '1px solid gray'
        }}>

            <div className="container p-4">
                <section className="mb-4">

                    <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.facebook.com/500DegreesAU/" role="button"
                    ><i className="fab fa-facebook-f"></i
                    ></a>

                    <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.instagram.com/500.degrees/" role="button"
                    ><i className="fab fa-instagram"></i
                    ></a>


                    <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.youtube.com/channel/UCHSvwq0JFr-xxAnw3ySxFyw" role="button"
                    ><i className="fab fa-youtube"></i
                    ></a>


                    <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.tiktok.com/@500.degrees" role="button"
                    ><i className="fab fa-tiktok"></i
                    ></a>
                </section>

                <section className="mt-5 d-flex flex-column flex-lg-row justify-content-center align-items-center  col-10 mx-auto">
                    <div className="me-lg-5 mb-3 mb-lg-0">
                        <span>
                            <h2 className="chelsea-font">Cronulla</h2>
                            <p>10 Cronulla Street, Cronulla, NSW 2230</p>
                        </span>
                    </div>
                    <div className="me-lg-5 mb-3 mb-lg-0">
                        <span>
                            <h2 className="chelsea-font">Kogarah</h2>
                            <p>13 Belgrave st, kogarah , NSW 2217</p>
                        </span>
                    </div>
                    <div>
                        <span>
                            <h2 className="chelsea-font">Parramatta</h2>
                            <p>46 Macquarie st, Parammatta, NSW 2150</p>
                        </span>
                    </div>
                </section>
            </div>

            <div className="text-center p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                <small>© {new Date().getFullYear()} Copyright, Application Developed By <a target="_blank" className="text-success fw-bold" href="https://saalim-shadman.web.app/">Saalim Shadman</a> for 500 Degrees Steakhouse</small>
            </div>

        </footer>

    );
};

export default Footer;